export const removeEmptyLabelHref = htmlString => {
	return htmlString.replace(
		/href[^>]*?\*emptyLabelUrl\*[ "']|href[^>]*?\*emptyLabelUrl\*(?=>)/gs,
		'',
	);
};
